/* Hero poster carousel: scroll-snap track, arrows, autoplay that pauses on hover/focus and respects reduced motion. */
if (!customElements.get('hp-carousel')) {
  class HpCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.hp-car__track');
      this.slides = Array.from(this.querySelectorAll('.hp-slide'));
      if (!this.track || this.slides.length < 2) return;

      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.querySelector('.hp-car__arrow--prev')?.addEventListener('click', () => this.go(-1));
      this.querySelector('.hp-car__arrow--next')?.addEventListener('click', () => this.go(1));

      const wantsAutoplay = this.dataset.autoplay === 'true' && !this.reduceMotion;
      if (wantsAutoplay) {
        this.delay = parseInt(this.dataset.interval, 10) || 6000;
        ['mouseenter', 'focusin', 'touchstart'].forEach((e) => this.addEventListener(e, () => this.stop(), { passive: true }));
        ['mouseleave', 'focusout'].forEach((e) => this.addEventListener(e, () => this.start()));
        document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()));
        this.start();
      }

      /* Re-align on resize so the active slide stays in view. */
      let t;
      window.addEventListener('resize', () => {
        clearTimeout(t);
        t = setTimeout(() => this.track.scrollTo({ left: this.index() * this.track.clientWidth, behavior: 'auto' }), 150);
      });
    }

    disconnectedCallback() {
      this.stop();
    }

    index() {
      return Math.round(this.track.scrollLeft / this.track.clientWidth);
    }

    go(direction) {
      const count = this.slides.length;
      const next = (this.index() + direction + count) % count;
      this.track.scrollTo({ left: next * this.track.clientWidth, behavior: this.reduceMotion ? 'auto' : 'smooth' });
    }

    start() {
      if (!this.delay) return;
      this.stop();
      this.timer = setInterval(() => this.go(1), this.delay);
    }

    stop() {
      clearInterval(this.timer);
    }
  }

  customElements.define('hp-carousel', HpCarousel);
}
